import { useEffect, useState } from 'react';
import { PromotionsBlockProps } from '../types';
import './styles.scss';
import { useIsDesktop } from 'utils';
import { checkIfOlderOsVersions } from 'utils';

export const ProductMadnessValueBlock: React.FC<PromotionsBlockProps> = ({
  mobileLogoImage,
  desktopLogoImage,
  backgroundImage,
  storeSaleImage,
  playerLevelImage,
}) => {
  const isDesktop = useIsDesktop();
  const [oldBrowserClass, setOldBrowserClass] = useState('');

  useEffect(() => {
    if (checkIfOlderOsVersions()) {
      setOldBrowserClass('jackpot-slots-promotions__inner-image--ios13');
    }
  }, []);

  return (
    <>
      {isDesktop && (
        <div className={'jackpot-slots-desktop-logo'}>
          <img src={desktopLogoImage} alt={'store logo'} />
        </div>
      )}
      <div className={'jackpot-slots-promotions'}>
        {!isDesktop && (
          <div className={'jackpot-slots-promotions__logo'}>
            <img src={mobileLogoImage} alt={'logo'} />
          </div>
        )}

        <div className={'jackpot-slots-promotions__background'}>
          <img src={backgroundImage} alt={'background'} />
        </div>

        <div className={'jackpot-slots-promotions__images_container'}>
          <div
            className={`jackpot-slots-promotions__inner-image ${oldBrowserClass}`}
          >
            {playerLevelImage && (
              <img src={playerLevelImage} alt={'player-level'}></img>
            )}
          </div>

          <div
            className={`jackpot-slots-promotions__inner-image ${oldBrowserClass}`}
          >
            {storeSaleImage && (
              <img src={storeSaleImage} alt={'store-sale'}></img>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
